<div #appendHere>
  <div class="qns-noquestions-background" [hidden]="blankText">
    <div class="qns-noquestions"><span class="qns-noquestions-span">Add questions here by clicking the </span><mat-icon>add_circle</mat-icon><span> icon on the left menu.</span></div>
  </div>
</div>
